import React from 'react';
import { NavBar } from '../../../components/essentials/navbar/navbar.component';
import { Footer } from '../../../components/essentials/footer/footer.component';
import {Getstarted} from '../../../components/essentials/get-started/getstarted.component';
import { OverlapBoxTechno } from '../../technopage/techno.component';
//import {  OverlapBoxFeature } from '../features-page/features-page.component';
//import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
//import benefits from '../../../assest/passwordless-soln/MFA T (1).png'
import benefits2 from '../../../assest/passwordless-soln/MFA Benefits (2).webp'
import benefits3 from '../../../assest/passwordless-soln/MFA Standards (1).png'
import kysBulletPoint from '../../../assest/2 - Solutions - Platforms/secure-payment.svg';
import phoneImg from '../../../assest/phoneImg/passwordless authentication-02.png';
import './passwordless.styles.scss';
import TrackedSection from '../../../components/essentials/google/GoogleAnalytics';
import { useTranslation } from 'react-i18next';

import benefits_US from '../../../assest/passwordless-soln/benefits_US.png';
import benefits_GB from '../../../assest/passwordless-soln/benefits_GB.png';


export const Passwordless = () => {
  const { t } = useTranslation('passwordless');

  const benefitsImageMap = {
    benefits_US,
    benefits_GB
  };

  const selectedBenefitsImageKey = t('benefitsImageKey'); // From JSON
  const benefits = benefitsImageMap[selectedBenefitsImageKey] || benefits_US;

  return (
    <div className='blogs-main'>
      <NavBar />
      <HeaderHalf title={t('title')} uris={t('uri')} />

      <OverlapBoxTechno
        img={phoneImg}
        title={t('section1.title')}
      >
        <TrackedSection sectionName="PasswordlessPage IntroSection">
          <p>{t('section1.intro1')}</p>
          <p>{t('section1.intro2')}</p>
          <p>{t('section1.intro3')}</p>
          <p>{t('section1.intro4')}</p>
        </TrackedSection>
      </OverlapBoxTechno>

      <SectionRight3
        title={t('section2.title')}
        desc={t('section2.desc')}

        title1={t('section2.title1')}
        content1={t('section2.content1')}

        title2={t('section2.title2')}
        content2={t('section2.content2')}

        title3={t('section2.title3')}
        content3={t('section2.content3')}

        title4={t('section2.title4')}
        content4={t('section2.content4')}

        title5={t('section2.title5')}
        content5={t('section2.content5')}

        title6={t('section2.title6')}
        content6={t('section2.content6')}

        imgPath={benefits}
        icon={kysBulletPoint}
        customClass="feature-box-image2"
      />

      <SectionRight2
        title={t('section3.title')}

        title1={t('section3.title1')}
        content1={t('section3.content1')}

        title2={t('section3.title2')}
        content2={t('section3.content2')}

        title3={t('section3.title3')}
        content3={t('section3.content3')}

        title4={t('section3.title4')}
        content4={t('section3.content4')}

        title5={t('section3.title5')}
        content5={t('section3.content5')}

        imgPath={benefits2}
        customClass="feature-box-image2"
        icon={kysBulletPoint}
        titlesub={t('section3.title')}
      />

      <SectionRight3
        title={t('section4.title')}
        desc={t('section4.desc')}

        title1={t('section4.title1')}
        content1={t('section4.content1')}

        title2={t('section4.title2')}
        content2={t('section4.content2')}

        title3={t('section4.title3')}
        content3={t('section4.content3')}

        title4={t('section4.title4')}
        content4={t('section4.content4')}

        title5={t('section4.title5')}
        content5={t('section4.content5')}

        title6={t('section4.title6')}
        content6={t('section4.content6')}

        imgPath={benefits3}
        icon={kysBulletPoint}
        customClass="feature-box-images"
      />

      <Getstarted />
      <Footer />
    </div>
  );
};

//dafh
const HeaderHalf = ({ title, uris }) => {
  return (
    <div className='headerHalf-main-pl'>
      <div className='headerHalf-content'>
        <p className='headerHalf-title'>{title}</p>
        <p className='headerHalf-uris'>
        Solutions / <span className='uris-class'>{uris}</span>
        </p>
      </div>
    </div>
  );
};

const KYSCard = ({ icon, desc, title }) => {
  return (
    <div className='kys-card'>
      <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
      <div className="key-text-col">
        <p className='kys-card-title'>{title}</p>
        <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
      </div>
    </div>
  );
};

// const KDTCard = ({ icon, desc, title }) => {
//   return (
//     <div className='kys-card'>
//       <div ><img src={icon} className='kdt-card-icon' alt='kysCardIcon' /></div>
//       <div >
//         <p className='kys-card-title'>{title}</p>
//         <p className='kdt-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
//       </div>
//     </div>
//   );
// };
// const EarthidBox = props => {
//   return (
//     <div className='kys-div'>
//       <div className='kys-platform-content'>
//         <KYSCard icon={kysBulletPoint} title='ID Wallet with PKI'
//           desc='EarthID’s ID Wallet securely stores public-private key pairs, enabling users to authenticate by signing cryptographic challenges. This wallet-based approach provides robust security through Public Key Infrastructure (PKI) and is designed for advanced users seeking high levels of cryptographic assurance. Ideal for securing sensitive systems, the PKI method ensures no passwords are stored or transmitted, reducing vulnerability to phishing and breaches.'
//         />
//         <KYSCard icon={kysBulletPoint} title='ID Wallet with Decentralized Identity'
//           desc='EarthID supports decentralized identity systems using Decentralized Identifiers (DIDs). This solution allows users to securely store and manage their digital identities, offering privacy-preserving authentication without relying on centralized authorities. With DIDs, users can authenticate themselves by proving their identity without revealing unnecessary personal information, making it particularly beneficial for privacy-conscious applications.'
//         />

//         <KYSCard icon={kysBulletPoint} title='Platform Authenticator (Face ID, Fingerprint)'
//           desc="EarthID leverages platform authenticators, such as Face ID and Fingerprint, to provide phishing-resistant, seamless authentication. These built-in device biometric methods securely bind credentials to the user’s device, ensuring both security and ease of use. This is ideal for users who prefer biometric login options without the need for additional hardware or complex setup."
//         />
        
//       </div>
//       <div className='kys-platform-content'>
       
//       <KYSCard icon={kysBulletPoint} title='TOTP via Authenticator App'
//           desc='Time-based One-Time Passwords (TOTP) add an extra layer of security by generating codes via popular authenticator apps like Google Authenticator and Authy. EarthID integrates with these apps to provide secure two-factor authentication (2FA) that enhances protection for accounts, especially for sensitive transactions or high-risk scenarios.'
//         />
//         <KYSCard icon={kysBulletPoint} title='Passkeys (Cloud-Synced)'
//           desc='Passkeys provide a seamless, passwordless login experience across devices by using FIDO2 and WebAuthn standards. These cryptographic keys are securely stored in cloud-based services like iCloud Keychain and Google Password Manager, allowing users to authenticate across multiple devices without needing passwords. This method ensures high security by binding the passkey to the user’s device, preventing phishing and credential theft.'
//         />
//         <KYSCard icon={kysBulletPoint} title='Magic Links'
//           desc='EarthID offers Magic Links as a simple, secure passwordless option for login. Users receive a one-time-use link in their email, allowing them to log in with a single click. This method is ideal for users who prefer a quick and straightforward login experience while still ensuring security. Magic Links can also be combined with additional MFA layers for higher security environments.'
//         />
//       </div>
//       <div className='kys-platform-img'> <img src={benefits} className='kys-platform-imagee' alt='kysCardIcon' /></div>

//     </div>


//   );
// };


// const KYSCard = ({ icon, desc, title }) => {
//   return (
//     <div className='kys-card'>
//       <div className="key-icon-col"><img src={icon} className='kys-card-icon' alt='kysCardIcon' /></div>
//       <div className="key-text-col">
//         <p className='kys-card-title'>{title}</p>
//         <p className='kys-card-desc'>{!desc ? 'right now description is not available' : desc}</p>
//       </div>
//     </div>
//   );
// };

// const SectionRight = props => {
//   return (
//     <div className='feature-box-rightspl'>
//       <p className='title-feature'>{props.title}</p>
//       <p className='desc1-feature'>{props.desc}</p>
//       <p className='title1-feature'>{props.titlesub}</p>
//           <div className={`feature-box-images ${props.customClass}`}>
//         <img src={props.imgPath} alt="feature-img" />
//       </div>
//       <div className="display-flex">
//         <div className='feature-box-contentpl'>
//           <div className='overallcontent'>
          
//           <p className='title1-feature'>{props.title1}</p>
//         <p className='content1-feature'>{props.content1}</p>
//         <p className='title1-feature'>{props.title2}</p>
//         <p className='content1-feature'>{props.content2}</p>
//         <p className='title1-feature'>{props.title3}</p>
//         <p className='content1-feature'>{props.content3}</p>
       
       
//           </div>
        
//         </div>
//         <div className='feature-box-contentpl'>
//           <div className='overallcontent'>
          
//           <p className='title1-feature'>{props.title4}</p>
//           <p className='content1-feature'>{props.content4}</p>
//         <p className='title1-feature'>{props.title5}</p>
//         <p className='content1-feature'>{props.content5}</p>
//         <p className='title1-feature'>{props.title6}</p>
//         <p className='content1-feature'>{props.content6}</p>
//         <p className='title1-feature'>{props.title7}</p>
//         <p className='content1-feature'>{props.content7}</p>
//           </div>
        
//         </div>
//       </div>
//     </div>
//   );
// };

const SectionRight2 = props => {
  return (
    <div className='feature-box-rights'>
      <p className='title-feature'>{props.title}</p>
      <p className='desc1-feature'>{props.desc}</p>
     
        <div className='kys-div'>
          <div className='kys-platform-content'>
            <p className='title1-feature'>{props.titlesub}</p>

            {/* Conditionally render KDTCard if both title1 and content1 exist */}
            {props.title1 && props.content1 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title1}
                desc={props.content1}
              />
            )}

            {/* Conditionally render KYSCard if both title2 and content2 exist */}
            {props.title2 && props.content2 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title2}
                desc={props.content2}
              />
            )}

            {/* Conditionally render KYSCard if both title3 and content3 exist */}
            {props.title3 && props.content3 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title3}
                desc={props.content3}
              />
            )}

            {/* Conditionally render KYSCard if both title4 and content4 exist */}
            {props.title4 && props.content4 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title4}
                desc={props.content4}
              />
            )}

            {/* Conditionally render KYSCard if both title5 and content5 exist */}
            {props.title5 && props.content5 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title5}
                desc={props.content5}
              />
            )}

            {/* Conditionally render KYSCard if both title6 and content6 exist */}
            {props.title6 && props.content6 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title6}
                desc={props.content6}
              />
            )}

            {/* Conditionally render KYSCard if both title7 and content7 exist */}
            {props.title7 && props.content7 && (
              <KYSCard
                icon={props.icon || kysBulletPoint}
                title={props.title7}
                desc={props.content7}
              />
            )}
          </div>
          <div className={'kys-platform-imgdt'}>
          <img src={props.imgPath} className='kys-platform-imageedt' alt="feature-img" />
        </div>
        </div>

       
     
    </div>
  );
};


const SectionRight3 = props => {
  return (
    <div className='feature-box-rights'>
      <p className='title-feature'>{props.title}</p>
      <p className='desc1-feature'>{props.desc}</p>
      <div className='kys-platform-img-top'>
        <img src={props.imgPath} className='kys-platform-image' alt='EarthID Image' />
      </div>
      <div className="kys-div">
        <div className='kys-platform-content'>
          {props.title1 && props.content1 && (
            <KYSCard
              icon={props.icon || kysBulletPoint}
              title={props.title1}
              desc={props.content1}
            />
          )}
          {props.title2 && props.content2 && (
            <KYSCard
              icon={props.icon || kysBulletPoint}
              title={props.title2}
              desc={props.content2}
            />
          )}
          {props.title3 && props.content3 && (
            <KYSCard
              icon={props.icon || kysBulletPoint}
              title={props.title3}
              desc={props.content3}
            />
          )}
        </div>
        <div className='kys-platform-content'>
          {props.title4 && props.content4 && (
            <KYSCard
              icon={props.icon || kysBulletPoint}
              title={props.title4}
              desc={props.content4}
            />
          )}
          {props.title5 && props.content5 && (
            <KYSCard
              icon={props.icon || kysBulletPoint}
              title={props.title5}
              desc={props.content5}
            />
          )}
          {props.title6 && props.content6 && (
            <KYSCard
              icon={props.icon || kysBulletPoint}
              title={props.title6}
              desc={props.content6}
            />
          )}
        </div>
      </div>

     
    </div>
  );
};
